import { createApi } from '@reduxjs/toolkit/query/react';
import config from 'config/index';
import axiosBaseQuery from 'rtk/query/axiosBaseQuery';

import { EUserType } from 'types/accessControll.types';
import type { TApplication } from 'types/application.types';
import type { TCandidate } from 'types/candidate.types';
import type { TInterview } from 'types/interview.types';
import type { TJob } from 'types/job.types';
import type { TPaginationRequest, TPaginationResult } from '../api-common.types';

type TApplicationData = TApplication & { interviews: TInterview[]; job: TJob };
export type TCandidateData = TCandidate & { applications: TApplicationData[] };
export type TFindPaginatedCandidatesRequest = TPaginationRequest<{ text: string }>;

const reducerPath = 'candidates' as const;
const path = 'v1/candidates' as const;

export const candidatesApi = createApi({
  reducerPath: reducerPath,
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.VITE_BACKEND_URL}/${path}`,
  }),
  tagTypes: ['Candidate'],
  endpoints: (builder) => ({
    findPaginatedCandidates: builder.query<TPaginationResult<TCandidate>, TFindPaginatedCandidatesRequest>({
      query: (payload) => {
        return {
          url: `/paginated-find`,
          method: 'POST',
          data: payload,
          headers: { 'X-Access-Control': EUserType.HUBERT },
        };
      },
    }),

    getCandidatePageData: builder.query<{ candidate: TCandidateData }, { candidateId: string | undefined }>({
      query: (x) => {
        return {
          url: `/${x.candidateId}`,
          method: 'GET',
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
      providesTags: ['Candidate'],
    }),
    getCandidatePageDatav2: builder.query<{ candidate: TCandidateData }, { candidateId: string | undefined }>({
      query: (x) => {
        return {
          url: `/candidatePageData/${x.candidateId}`,
          method: 'GET',
          headers: { 'X-Access-Control': EUserType.ANY },
        };
      },
      providesTags: ['Candidate'],
    }),
  }),
});

export const {
  // Queries
  useFindPaginatedCandidatesQuery,
  useGetCandidatePageDatav2Query,
  // Mutations
} = candidatesApi;
